import { motion } from 'framer-motion';
import { SKILL_GROUPS } from '../data/projects';

const Skills = () => {
  return (
    <section id="skills" className="section skills">
      <div className="section__inner">
        <motion.p
          className="section__eyebrow"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Technical skills
        </motion.p>
        <motion.h2
          className="section__title"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          Stack I work with
        </motion.h2>

        <div className="skills__groups">
          {SKILL_GROUPS.map((group, gi) => (
            <motion.div
              key={group.group}
              className="skills__group"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.65, delay: gi * 0.06 }}
            >
              <h3>{group.group}</h3>
              <ul>
                {group.items.map((skill, i) => (
                  <motion.li
                    key={skill}
                    initial={{ opacity: 0, scale: 0.92 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.35, delay: 0.03 * i + gi * 0.04 }}
                    whileHover={{ y: -3 }}
                  >
                    {skill}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
